import React, { useState } from 'react';
import { Typography, TextField, Button, ButtonGroup, Box } from '@mui/material';
import SEO, { createSoftwareAppSchema } from '../../components/SEO';
import ToolPageContainer from '../../components/ToolPageContainer';
import {
  PanelGroup,
  Panel,
  PanelResizeHandle,
} from 'react-resizable-panels';

const HtmlEntityEncoderDecoder = () => {
  const [input, setInput] = useState('<p>Hello & Welcome!</p>');
  const [output, setOutput] = useState('&lt;p&gt;Hello &amp; Welcome!&lt;/p&gt;');
  const [error, setError] = useState('');

  // Basic implementation, not exhaustive
  const entities = {
    '<': '&lt;',
    '>': '&gt;',
    '&': '&amp;',
    '"': '&quot;',
    "'": '&#39;',
  };
  const reversedEntities = Object.fromEntries(Object.entries(entities).map(([key, value]) => [value, key]));

  const handleEncode = () => {
    try {
      setError('');
      const encoded = input.replace(/[<>&"']/g, char => entities[char]);
      setOutput(encoded);
    } catch (e) {
      setError('Failed to encode entities.');
      setOutput('');
    }
  };

  const handleDecode = () => {
    try {
      setError('');
      const decoded = input.replace(/&lt;|&gt;|&amp;|&quot;|&#39;/g, entity => reversedEntities[entity]);
      setOutput(decoded);
    } catch (e) {
      setError('Failed to decode entities.');
      setOutput('');
    }
  };

  return (
    <>
      <SEO
        title="HTML Entity Encoder/Decoder | Text Tools | UmbrellaCo"
        description="Encode and decode HTML entities instantly. Secure, browser-based tool to convert special characters for safe web display."
        keywords="html entity encoder, html decoder, escape html characters, html encode online, web tools"
        url="/text-tools/html-entity"
        jsonLd={createSoftwareAppSchema(
          'HTML Entity Encoder/Decoder',
          'Safely encode and decode HTML entities directly in your browser.',
          'https://umbrellaco.in/text-tools/html-entity',
          ['HTML Encoding', 'Web Development', 'Text Tools']
        )}
      />
      <ToolPageContainer
        title="HTML Entity Encoder/Decoder"
        description="Convert special characters to their corresponding HTML entities to safely display code snippets, or decode them back to plain text."
      >
      <PanelGroup direction="vertical" style={{ height: '400px', marginTop: '16px' }}>
        <Panel>
          <TextField
            label="Input"
            multiline
            rows={7}
            value={input}
            onChange={(e) => setInput(e.target.value)}
            variant="outlined"
            fullWidth
            sx={{ height: '100%', '& .MuiInputBase-root': { height: '100%' } }}
          />
        </Panel>
        <PanelResizeHandle style={{ height: '10px', background: '#f0f0f0' }} />
        <Panel>
          <TextField
            label="Output"
            multiline
            rows={7}
            value={output}
            InputProps={{ readOnly: true }}
            variant="outlined"
            fullWidth
            sx={{ height: '100%', '& .MuiInputBase-root': { height: '100%' } }}
          />
        </Panel>
      </PanelGroup>
      <ButtonGroup variant="contained" sx={{ mt: 2 }}>
        <Button onClick={handleEncode}>Encode</Button>
        <Button onClick={handleDecode}>Decode</Button>
      </ButtonGroup>
      {error && <Typography color="error" sx={{ mt: 2 }}>{error}</Typography>}
      </ToolPageContainer>
    </>
  );
};

export default HtmlEntityEncoderDecoder;
